import { render, staticRenderFns } from "./de-investors.vue?vue&type=template&id=018345a7"
import script from "./de-investors.vue?vue&type=script&lang=js"
export * from "./de-investors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports